import {
    apiRequest,
    sampleDetail
} from "../../../../../services/adapters/base"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", sampleDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository